import { SessionInfo } from '../types';

interface EnvironmentBadgeProps {
  environment: SessionInfo['environment'];
}

const EnvironmentBadge = ({ environment }: EnvironmentBadgeProps) => {
  const isProduction = environment === 'production';
  
  return (
    <div className="absolute top-4 right-4">
      <div
        className={`
          px-3 py-1.5 rounded-full text-xs font-medium
          ${isProduction
            ? 'bg-success/10 text-success border border-success/20' :'bg-warning/10 text-warning border border-warning/20'
          }
        `}
      >
        {isProduction ? 'Produção' : 'Homologação'}
      </div>
    </div>
  );
};

export default EnvironmentBadge;